import PostingSupplyDetailForProduction from '@/models/PostingSupplyForProduction/PostingSupplyDetailForProduction';

export default class PostingSupplyDetailForProductionFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.postingSupplyForProductionId  = '';
		this.postingSupplyForProductionPickingSupplyForProduction = '';
		this.pickingSupplyForProductionDetailId  = '';
		this.pickingSupplyForProductionDetailMaterialPart = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.materialPartId  = '';
		this.materialPartPartNumber = '';
		this.qtySupply = '';
		this.picPickingId  = '';
		this.picPickingFirstName = '';
		this.picPenerimaId  = '';
		this.picPenerimaFirstName = '';
		this.lineId  = '';
		this.lineCode = '';
		this.postingDateFrom = '';
		this.postingDateTo = '';
		this.areaId  = '';
		this.areaCode = '';
		this.rackId  = '';
		this.rackCode = '';
		this.documentStatusId  = '';
		this.documentStatusName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			postingSupplyForProductionId : '0',
			postingSupplyForProductionPickingSupplyForProduction : '0',
			pickingSupplyForProductionDetailId : '0',
			pickingSupplyForProductionDetailMaterialPart : '0',
			partId : '0',
			partPartNumber : '0',
			materialPartId : '0',
			materialPartPartNumber : '0',
			qtySupply : '0',
			picPickingId : '0',
			picPickingFirstName : '0',
			picPenerimaId : '0',
			picPenerimaFirstName : '0',
			lineId : '0',
			lineCode : '0',
			postingDateFrom : '0',
			postingDateTo : '0',
			areaId : '0',
			areaCode : '0',
			rackId : '0',
			rackCode : '0',
			documentStatusId : '0',
			documentStatusName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}